import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/ResearchCourseDetails.css';

const ResearchCourseDetails = () => {
  const navigate = useNavigate();

  return (
    <div className="course-details-container">
      <button className="back-button" onClick={() => navigate('/services/research')}>
        ← Back to Research Consultancy
      </button>

      <h2 style={{ textAlign: 'center', marginBottom: '30px', color: '#ffc107' }}>
        Research Consultancy - Course Details
      </h2>

      <div className="course-section">
        <h3>Research Paper Write-up Assistance</h3>
        <ul>
          <li>Q3 & Q4 Scopus Paper – ₹50,000</li>
          <li>Q2 Scopus Paper – ₹70,000</li>
          <li>Q1 Scopus Paper – ₹90,000</li>
          <li>SCI Paper – ₹1,20,000</li>
          <li>Transaction Paper – ₹1,80,000 to ₹2,00,000</li>
          <li>Synopsis Writing – ₹20,000</li>
          <li>PPT Preparation – ₹20,000</li>
          <li>Thesis Writing – ₹60,000</li>
        </ul>
      </div>

      <div className="course-section">
        <h3>Research Paper Publishing Assistance</h3>
        <ul>
          <li>Publishing charges start from ₹40,000</li>
          <li>Exact cost depends on the type of journal</li>
        </ul>
      </div>
    </div>
  );
};

export default ResearchCourseDetails;
